import { parseSettings } from '@kc/core/ports'
import type { RawSettings, Settings, SettingsPort } from '@kc/core/ports'

const KEY = 'kc.settings.v1'

/**
 * 核心只认 newPerDay。这里存原始 JSON，读的时候交给 parseSettings，
 * 这样非法值/未知键的处理与核心保持同一套规则。
 */
export class LocalSettingsPort implements SettingsPort {
  async read(): Promise<RawSettings> {
    try {
      const raw = localStorage.getItem(KEY)
      if (raw === null) return { newPerDay: 10 }
      const value: unknown = JSON.parse(raw)
      return typeof value === 'object' && value !== null && !Array.isArray(value)
        ? (value as RawSettings)
        : { newPerDay: 10 }
    } catch {
      return { newPerDay: 10 }
    }
  }

  async write(settings: Settings): Promise<void> {
    try {
      localStorage.setItem(KEY, JSON.stringify({ newPerDay: settings.newPerDay }))
    } catch {
      // 隐私模式/配额满：本次内存生效，下次重填。
    }
  }

  /** 供界面显示当前生效值；核心在 openWorkspace 里已经解析过。 */
  static current(raw: RawSettings): Settings {
    return parseSettings(raw).settings
  }
}
